import { render, staticRenderFns } from "./HotArticleCardAdult.vue?vue&type=template&id=3ab60830&"
import script from "./HotArticleCardAdult.vue?vue&type=script&lang=js&"
export * from "./HotArticleCardAdult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports